import Api from '@/common/fetch.js'
import { apiRoute, reverseApiRoute } from '@/common/config'

export default {
    getParkingCost (request) {
        return Api.post(apiRoute + '/getParkingCost', request)
    },
    registerPayment (request) {
        return Api.post(apiRoute + '/registerPayment', request)
    },
    registerPaymentToken (request, token) {
        const headers = {
            'Authorization': token
        }
        return Api.post(apiRoute + '/registerPayment', request, { headers: headers })
    },
    failedPayment (request) {
        return Api.post(apiRoute + '/failedPayment', request)
    },
    reversePayment (request) {
        // https://3dsec.sberbank.ru/payment/rest/reverse.do
        return Api.post(reverseApiRoute + '/reversePayment', request)
    },
    walletWriting (request) {
        return Api.post(apiRoute + '/walletWriting', request)
    }
}
